import React, { memo, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../helper/Countdown';

const SampleNextArrow = memo(function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
});

const SamplePrevArrow = memo(function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
});

const FlashSalesOne = () => {
    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [{ breakpoint: 991, settings: { slidesToShow: 1 } }],
    };

    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const [categories, setCategories] = useState([]);

    const WC_URL = process.env.REACT_APP_WC_URL;
    const CK = process.env.REACT_APP_WC_CK;
    const CS = process.env.REACT_APP_WC_CS;

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await fetch(
                    `${process.env.REACT_APP_BACKEND_URL}/api/flash-sales/?per_page=100`
                );

                const data = await res.json();

                if (data.status) {
                    setCategories(data.data);
                } else {
                    console.error("Category fetch failed:", data.error);
                }
            } catch (err) {
                console.error("Category fetch error:", err);
            }
        };

        fetchCategories();
    }, []);

    // 🔥 Find Flash Sales Today category and its subcategories
    const flashParent = categories.find(cat => cat.slug === "flash-sales-today");
    const flashSubCategories = categories.filter(cat => cat.parent === flashParent?.id);

    return (
        <section className="flash-sales pt-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Flash Sales Today</h5>

                        <div className='flex-align mr-point gap-16'>
                            <Link
                                to="/shop"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                View All Deals
                            </Link>
                        </div>

                    </div>
                </div>

                <div className="flash-sales__slider arrow-style-two">
                    <Slider {...settings}>
                        {flashSubCategories.map((cat) => (
                            <div key={cat.id}>
                                <div
                                    className="flash-sales-item rounded-16 overflow-hidden z-1 position-relative flex-align flex-0 justify-content-between gap-8"
                                    style={{ width: "100%", minHeight: "220px" }}
                                >

                                    {/* 🔹 Background Image (blurred) */}
                                    <img src={cat.image?.src} alt={cat.name} className="position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 object-fit-cover z-n1 flash-sales-item__bg" />

                                    {/* 🔹 Content */}
                                    <div className="flash-sales-item__content ms-sm-auto">
                                        <h6></h6>
                                        <Link
                                            to={`/shop?category=${cat.slug}`}
                                            className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8 mt-24"
                                        >
                                            Shop Now
                                            <span className="icon text-xl d-flex">
                                                <i className="ph ph-arrow-right" />
                                            </span>
                                        </Link>
                                    </div>

                                </div>
                            </div>
                        ))}

                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default FlashSalesOne;
